export const AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS = {
  SET_AUDIO_PREFERENCE: "audioAndSubtitlesPreferences/SET_AUDIO_PREFERENCE",
  SET_SUBTITLES_PREFERENCE: "audioAndSubtitlesPreferences/SET_SUBTITLES_PREFERENCE"
};

export const setAudioPreference = (audioLanguagePreference) => ({
  type: AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS.SET_AUDIO_PREFERENCE,
  payload: audioLanguagePreference
});

export const setSubtitlesPreference = (subtitleLanguagePreference) => ({
  type: AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS.SET_SUBTITLES_PREFERENCE,
  payload: subtitleLanguagePreference
});
